import React, { useEffect, useRef, useState } from 'react';
import { ProfileIcon, RingIcon, WalletIcon } from "../../icons/icons";
import { useTranslation } from "react-i18next";

import Broadcast from "../broadcast/broadcast";
import CustomLink from "../UI/customLink/customLink";
import useDirection from "../../hooks/useDirection";
import { useSelector } from "react-redux";
import { Separate } from "../../utils/separate";
import { Get, Post } from "../../apis/api";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import DropDown from "../../assets/dropDown/dropDown";
import Pagination from "../pagination/pagination";
import OpenMail from "../../assets/img/mail.png"
import CloseMail from "../../assets/img/email.png"
import Avatar from "../../assets/img/avatar.png"
import { useNotifications, useWallet } from '../../hooks';
import Loading from '../Loading';

const Header = () => {

  const { t, i18n } = useTranslation();
  const [lng, setLng] = useState("fa")
  const [profileModal, setProfileModal] = useState(false)
  const dir = useDirection()
  const selectRef = useRef(null);
  const selectRefNotif = useRef(null);
  // const [walletDeposit, setWalletDeposit] = useState(null)
  // const [notificationList, setNotificationList] = useState(null)
  const [openNotif, setOpenNotif] = useState(false)
  const [conuterNotif, setCounterNotif] = useState(0)
  const [creditDeposit, setCreditDeposit] = useState(null)
  const [loading, setLoading] = useState(false)
  const [perPage, setPerPage] = useState(10)
  const [notifPage, setNotifPage] = useState(1)
  const user = useSelector((state) => state.user.user)
  const navigate = useNavigate()

  const { isLoading: loadingWallet, data: walletData } = useWallet()

  const { data: notifsData, isLoading } = useNotifications(notifPage, 10, user?.role_key === "super_admin")

  useEffect(() => {
    if (notifsData) {

      setCounterNotif(
        notifsData?.details?.data?.data?.filter((item) => {
          return (item.read === 0)
        })?.length
      )
    }
  }, [notifsData])

  const notificationList = notifsData?.details?.data

  const changeLanguage = (lng) => {
    setLng(lng)
    i18n.changeLanguage(lng).then((res) => {
      console.log(res)
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setProfileModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectRef]);


  useEffect(() => {
    if ((user?.role_key === "client" || user?.role_key === "agent"))
      handleDeposit()
  }, [])

  // useEffect(() => {
  //   if(user?.role_key === "super_admin" )
  //   notification(notifPage || 1)
  // } ,[user?.role_key])

  // const notification = (page , per_page, search="") => {
  //   setNotifPage(page)
  //   setInterval(() => {
  //     Get(`notification/unread?page=${page || notifPage}&per_page=${per_page || 10}` ).then((res) =>{
  //       setNotificationList(res?.details?.data)
  //       setCounterNotif(
  //         res?.details?.data?.data?.filter((item) => {
  //           return (item.read === 0)
  //         })?.length
  //       )
  //     }).finally(() => {
  //       setLoading(false)
  //     })
  //   } , 10000)
  // }


  const handleDeposit = () => {
    setLoading(true)
    // Get(`agent/transactions/wallets/deposit`).then((res) => {
    //   setWalletDeposit(res?.details?.data)
    // }).finally(() => {
    //   setLoading(false)
    // })
    Get(`agent/transactions/credit/deposit`).then((res) => {
      setCreditDeposit(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleRead = (item) => {
    Post(`notification/read/${item?.id || localStorage.getItem("visaId")}`)
      .then((res) => {
        navigate(`/visa-orders/forms/${item?.variables.split(",")[0].replace("[", "")}`)
        setOpenNotif(false)
      })
      .catch((error) => {
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRefNotif.current && !selectRefNotif.current.contains(event.target)) {
        setOpenNotif(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectRefNotif]);

  return (
    <div className={"mb-5 bg-white "}>
      <div className={"my-container flex items-center justify-between  py-5 h-[55px]"}>
        <div className={"flex items-center"}>
          <Broadcast title={""} />
        </div>
        <div className={"flex gap-3 items-center"}>
          <button className={"mx-1 md:mx-5 p-2 bg-main text-white cursor-pointer rounded-full h-[30px] w-[30px] flex items-center justify-center border-2"} onClick={() => changeLanguage(lng === "en" ? "fa" : "en")}>{lng === "en" ? <span className={"font-semibold mt-1 "}>{"FA"}</span > : <span className={"font-semibold mt-1"}>{"EN"}</span>}</button>

          {
            (user?.role_key === "client" || user?.role_key === "agent") &&
            <span className={"p-1 rounded-lg border border-gray-400 w-[110px] h-[35px] flex justify-between items-center cursor-pointer"}>
              <span className={"text-gray-900 text-center text-xs w-full flex flex-row items-center justify-center"}>
                {loadingWallet ?  <Loading /> :walletData?.details?.data?.amount?.toLocaleString()}
              </span>
              <WalletIcon />
            </span>
          }
          {
            (user?.role_key === "client" || user?.role_key === "agent") &&
            <span className={"p-1 rounded-lg border border-gray-400 w-[110px] h-[35px] flex justify-between items-center cursor-pointer"}>
              <span className={"text-gray-900 text-center text-xs w-full"}>
                {Separate(creditDeposit)}
              </span>
              <WalletIcon />
            </span>
          }
          {
            user?.role_key === "super_admin" &&
            <div ref={selectRefNotif} className={"relative p-1 rounded-lg border border-gray-400 w-[35px] h-[35px] flex justify-center items-center cursor-pointer"}>
              <span onClick={() => { setOpenNotif(!openNotif) }}>
                <RingIcon />
                {
                  conuterNotif > 0 &&
                  <span className={"absolute w-[20px] h-[20px] bg-red rounded-full flex justify-center items-center text-white top-0 p-2 "}>
                    {conuterNotif}
                  </span>
                }

              </span>
              <div className={`absolute border w-[300px] max-h-[350px] overflow-y-auto bg-white top-[10px] ${lng === "fa" ? " left-10" : "right-10"}  z-40 rounded-lg ${openNotif ? "flex" : "hidden"} flex flex-col p-2 gap-2`}>

                {
                  notificationList?.data?.map((item) => {
                    return (
                      <>
                        <div onClick={() => handleRead(item)} className={`text-gray-500 text-xs  text-black p-2 ${item.read === 0 ? "bg-primary-200" : ""} rounded font-medium grid grid-cols-4 border m-1`}>
                          <div className={"flex flex-col gap-3 col-span-3"}>
                            <div className={"flex items-center text-nowrap"}>
                              <div>{t("newRequest") + ' : '}</div>
                              <strong className={"text-[9px]"}>{item.text}</strong>
                            </div>
                            <div className={"flex items-center"}>
                              <span>{t("agent") + " : "}</span>
                              <strong>{" "}</strong>
                            </div>
                            <div className={"flex items-center"}>
                              <span>{t("trackingNumber") + " : "}</span>
                              <strong>{" "}</strong>
                            </div>
                            <div className={"flex items-center"}>
                              <span>{t("requestDate") + " : "}</span>
                              <strong>
                                {moment(item.updated_at).format(lng === "fa" ? 'jYYYY-jMM-jDD' : 'jYYYY-jMM-jDD')}
                              </strong>
                            </div>
                          </div>
                          <div className={"flex flex-col justify-center items-center"}>
                            <div className={"flex flex-col mt-5"}>
                              <img className={"w-[50px] h-[35px]"} src={Avatar} />
                            </div>
                            <div className={"flex flex-col mt-2"}>
                              <img className={"w-[30px] h-[30px]"} src={item.read === 0 ? OpenMail : CloseMail} />
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  })
                }
                {/*<div className={' flex flex-col  md:flex-row md:items-center md:justify-center mt-4'}>*/}
                {/*  <Pagination itemsPerPage={notificationList?.per_page} total={notificationList?.total} last_page={notificationList?.last_page}  changePage={(page) => notification(page , perPage)}/>*/}
                {/*</div>*/}
              </div>
            </div>
          }



          <span onClick={() => setProfileModal(!profileModal)} className={"p-1 rounded-lg border border-gray-400 w-[35px] h-[35px] flex justify-center items-center cursor-pointer relative"}>
            <ProfileIcon />
            <div ref={selectRef} className={`absolute top-5 ${dir ? "left-5" : "right-5"} ${profileModal ? "flex" : "hidden"} bg-white border rounded-lg p-4  flex-col justify-start items-start w-[200px] bg-white z-30`}>
              <span className={" text-sm"}>
                {(user?.name || "") + ' ' + (user?.last_name || "")}
              </span>
              <span className={"text-gray-500 text-xs pt-1"}>
                {user?.role_key}
              </span>
              <div className={"border-b w-full my-2"} />
              <div className={"text-gray-500 text-[10px]"}>
                {(user?.email)}
              </div>
              <div className={"w-full mt-4"}>
                <CustomLink styles={"!text-xs"} typeTwo link={"/profile"} title={t("userProfile")} />
              </div>
            </div>
          </span>

        </div>
      </div>
    </div>
  );
}

export default Header;
